const nav = [
    {
        text: "Home",
        to: "/",
    },
    {
        text: "Getting started",
        to: "/getting-started",
    },
    {
        text: "Styles",
        to: "/styles",
    },
    {
        text: "Layouts",
        to: "/layouts",
    },
    {
        text: "Icons",
        to: "/icons",
    },
    {
        text: "Components",
        to: "/components",
    },
    {
        text: "Helpers",
        to: "/helpers",
    },
]

export default nav